import React, { useEffect, useState } from 'react'
import { NormalHeading } from '../../../../Components/Utils/Heading';
import { BackButton, CancelButton, CreateButton, DownloadButton, EditButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import SideModal from '../../../../Components/Others/SideModel';
import DefaultDownloadLink from './pdf/DefaultDownloadLink';
import NuDate from '../../../../Components/Utils/NuDate';
import ViewPdf from './ViewPdf';
import Comments from './CommentsPr';
import CommonComments from '../../../../Components/Utils/commonComments';
import ApprovalComponent from '../../../../Components/Utils/approvalComponent';
import axiosInstance from '../../../../Services/axiosCommon';
import NuAmount from '../../../../Components/Utils/NuAmount';
import POPdfOther from '../../ViewPdfTemplate/POPdfOther';
import POPdfNu from '../../ViewPdfTemplate/POPdfNu';
import PDFViewer from '../../../../Components/Utils/PDFViewer';
import { GetAccess, GetRole } from '../../../../Components/Utils/roles';
import { useToast } from '../../../../Components/Others/ToastServices';
import Info from '../../../../Components/Icons/Info';
import { CalPercentage } from '../../../../Components/Utils/OtherFuction';
import QuoteComparisonModal from '../../../../Components/Utils/QuoteComparisonModal';
import { formatDisplaySno } from '../../../../Components/Utils/formatDisplaySno';

import { useQuery } from '@tanstack/react-query';

function ViewPo(poId) {
  const toast = useToast();
  const { poViewId } = useParams();
  const location = useLocation();

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const [data, setData] = useState(null);
  console.log(data, "data");

  // Fetch PO Details using React Query
  const { data: fetchedPoData, refetch: refetchPo } = useQuery({
    queryKey: ["PO-details", poViewId],
    queryFn: async () => {
      const res = await axiosInstance.get(`/PO/${poViewId}`);
      return res.data?.data || null;
    },
    enabled: !!poViewId,
    refetchOnMount: "always",
    staleTime: 0,
  });

  useEffect(() => {
    if (fetchedPoData) {
      setData(fetchedPoData);
    }
  }, [fetchedPoData]);

  const isLocal = Boolean(
    data?.isLocal === true ||
      data?.isLocal === "true" ||
      data?.isLocal === 1 ||
      fetchedPoData?.isLocal === true ||
      fetchedPoData?.isLocal === "true" ||
      fetchedPoData?.isLocal === 1
  );

  const { data: vatData } = useQuery({
    queryKey: ["vat-rate"],
    queryFn: async () => {
      const res = await axiosInstance.get("/vat/");
      return res.data?.data || null;
    },
    enabled: isLocal,
  });

  const vatRate = Number(vatData?.vatRate) || 0;

  const isApprovalVerified = () => {
    const status = (data?.approvalStatus || data?.status || "")?.toLowerCase()?.trim();
    return status === "approved";
  };

  const [showPdfComponent, setShowPdfComponent] = useState(false);
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [grnData, setGrnData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showQuoteComparison, setShowQuoteComparison] = useState(false);
  const [isLoadingQuote, setIsLoadingQuote] = useState(false);
  const [dataView, setDataView] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [dynamicHeaderCount, setDynamicHeaderCount] = useState(0);
  const [supplierList, setSuppliersList] = useState([]);
  const [stateValue, setStateValue] = useState([]);
  const [finalProId, setFfinalProId] = useState([]);

  const closeQouteComparison = () => {
    setShowQuoteComparison(false);
  };

  function getViewQuotes(prId) {
    if (!prId) return;
    setIsLoadingQuote(true);

    axiosInstance
      .get(`/supplier-quotations/quot-compare/${prId}`)
      .then((res) => {
        if (res.data) {
          setDataView(formatDisplaySno(res.data?.data?.products || []));
          setIsLoadingQuote(false);
          setProductCount(res?.data?.data?.products?.length || 0);
          setDynamicHeaderCount(
            res.data?.data?.vendorNames
              ? res.data?.data?.vendorNames.length
              : 0
          );
          setSuppliersList(res.data?.data?.vendorNames || []);
          setStateValue(res.data?.data?.vendors || []);
          let vendorsItem = res.data?.data?.vendors || [];
          let TempValue = [];
          vendorsItem.forEach((i) => {
            if (i.isSelected) {
              TempValue.push(i.id);
            }
          });
          setFfinalProId(TempValue);
        }
      })
      .catch((err) => {
        console.error(err);
        setIsLoadingQuote(false);
      });
  }

  const handleOpenCommentsModal = async () => {
    setIsCommentsModalOpen(true);
    setLoading(true);

    try {
      const response = await axiosInstance.get(`/grn/${poViewId}/history`);
      if (response.data.status) {
        setGrnData(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching GRN data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseCommentsModal = () => {
    setIsCommentsModalOpen(false);
    setGrnData(null);
  };

  const [pdfLoading, setPdfLoading] = useState(false);

  const handlePdfIconClick = async () => {
    if (!isApprovalVerified()) return;
    setShowPdfComponent(true);
    if (!viewPDF) {
      setPdfLoading(true);
      await ViewPDF();
      setPdfLoading(false);
    }
  };
  const closeFilterDialog = () => {
    setShowPdfComponent(false);
  };

  const id = poViewId;
  const getUrl = `/PO/get-status`;
  const putUrl = `/PO/edit-status`;
  const statusUrl = '/PO/all-status';
  const undoUrl = `/PO/undo-status`;
  const editUrl = '/PO/edit-reason';



  const downloadPDF = async () => {
    // if (!isApprovalVerified()) {
    //   toast.open({
    //     type: "warning",
    //     message: "Warning",
    //     description: "Document cannot be downloaded until the approval status is verified.",
    //   });
    //   return;
    // }
    try {
      const response = await axiosInstance.get(`/PO/download-pdf/${poViewId}`, {
        responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${data.ref}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);

    } catch (error) {
      console.error('Error downloading the PDF:', error);
    }
  };

  const [viewPDF, setViewPDF] = useState(null);

  const ViewPDF = async () => {
    try {
      const response = await axiosInstance.get(`/PO/download-pdf/${poViewId}`, {
        responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);

    } catch (error) {
      console.error('Error downloading the PDF:', error);
    }
  };
  // Removed automatic PDF fetch on load - fetch only when user clicks PDF preview

  const EditAccess = "purchase_order_edit"
  return (
    <div className="w-full h-full p p-2 lg:px-4 ">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[
              {
                name: "Purchase Order",
                link: "/procurement/purchase-order/",
              },
              { name: "View" },
            ]}
          />
          <div className="flex md:hidden items-center gap-2">
            <Link
              to={"/procurement/purchase-order"}
              state={{
                currentPage: pageIndex,
                searchQuery: searchQuery != "" ? searchQuery : "",
              }}
            >
              <BackButton link={true} />
            </Link>

            <DownloadButton
              handleClick={downloadPDF}
              label="Download as PDF"
            />
            {data?.editable === false ? (
              <>
                {GetRole() && (
                  <Link
                    to={`/procurement/purchase-order/edit/${poViewId}`}
                    state={{
                      data: data,
                      from: `/procurement/purchase-order/view/${poViewId}`,
                    }}
                  >
                    <EditButton height="8" />
                  </Link>
                )}
              </>
            ) : (
              <>
                {GetAccess(EditAccess) && (
                  <Link
                    to={`/procurement/purchase-order/edit/${poViewId}`}
                    state={{
                      data: data,
                      from: `/procurement/purchase-order/view/${poViewId}`,
                    }}
                  >
                    <EditButton height="8" />
                  </Link>
                )}
              </>
            )}
          </div>
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to={"/procurement/purchase-order"}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>

          <DownloadButton
            handleClick={downloadPDF}
            label="Download as PDF"
          />
          {data?.editable === false ? (
            <>
              {GetRole() && (
                <Link
                  to={`/procurement/purchase-order/edit/${poViewId}`}
                  state={{
                    data: data,
                    from: `/procurement/purchase-order/view/${poViewId}`,
                  }}
                >
                  <EditButton height="8" />
                </Link>
              )}
            </>
          ) : (
            <>
              {GetAccess(EditAccess) && (
                <Link
                  to={`/procurement/purchase-order/edit/${poViewId}`}
                  state={{
                    data: data,
                    from: `/procurement/purchase-order/view/${poViewId}`,
                  }}
                >
                  <EditButton height="8" />
                </Link>
              )}
            </>
          )}
        </div>
      </div>
      <div className="w-full mx-auto lg:h-[calc(100vh-125px)] overflow-y-auto rounded-md lg:p-2 flex flex-col lg:flex-row gap-3 text-[#111537]">
        <div className="w-full lg:w-[70%] bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden flex flex-col">
          <div className="w-[98%] bg-white px-2 mx-auto border border-gray py-2 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 z-10">
            <div className="grid items-center px-2 w-full sm:w-[70%]">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-full">
                <p className="">{data?.ref}</p>
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1">
                <p className="text-xs text-[#111537]">
                  Date :{" "}
                  {data?.createdAt ? (
                    <NuDate
                      value={data?.createdAt}
                      format="DD-MMM-YYYY, hh:mm A"
                    />
                  ) : (
                    "N/A"
                  )}
                </p>
                <p className="text-xs text-[#111537]">
                  {" "}
                  Created By : {data?.preparedByName || "None"}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-2 justify-between sm:justify-end w-full sm:w-[30%] items-start sm:items-end">
              <div className="pb-1 flex items-center gap-2 flex-wrap sm:flex-nowrap justify-end">
                {data?.prId && GetRole() && (
                  <div className="flex items-center">
                    <span
                      className="rounded-md py-1 px-2 text-baseColor-primary bg-slate-300 text-xs cursor-pointer hover:bg-slate-400 font-semibold whitespace-nowrap"
                      onClick={() => {
                        setShowQuoteComparison(true);
                        // getViewQuotes(data?.prId);
                      }}
                    >
                      View Quotes
                    </span>
                  </div>
                )}
                <Link
                  to={`/procurement/purchase-order/viewGrnIndex/${poViewId}`}
                  state={{
                    data: data,
                    from: `/procurement/purchase-order/view/${poViewId}`,
                  }}
                >
                  <p className="text-xs cursor-pointer text-white bg-[#6A9C89] rounded-md inline-flex w-auto whitespace-nowrap py-1 px-2 flex-shrink-0 items-center justify-center font-semibold">
                    GRN History
                  </p>
                </Link>
              </div>
              <div className="border rounded-md border-[#579BB1] text-xs inline-flex w-auto flex-shrink-0 justify-center">
                <p className="bg-white text-black p-1 rounded-l-md">
                  Status{" "}
                </p>
                <p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md">
                  {" "}
                  {data?.status || "None"}
                </p>
              </div>
            </div>
          </div>
          <div className="w-full flex-1 overflow-y-auto p-2 pb-8">
            <div className="w-full flex flex-wrap border border-gary mt-2 px-2 rounded-lg">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 py-1">
                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Req. Delivery Date
                  </p>
                  <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                    :{" "}
                    {data?.requestedDeliveryDate ? (
                      <NuDate
                        value={data?.requestedDeliveryDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>

                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Delivery Terms
                  </p>
                  <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                    : {data?.deliveryTerms || "N/A"}
                  </p>
                </div>
                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Payment Status
                  </p>
                  <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                    : {data?.paymentStatus || "N/A"}
                  </p>
                </div>

                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    {" "}
                    Currency
                  </p>
                  <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                    : {String(data?.vendorCurrency).toUpperCase()}
                  </p>
                </div>
                {data?.isEmailSent === true && (
                  <div className="w-full flex px-2 items-center">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                      Email Sent Date & Time
                    </p>
                    <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                      :{" "}
                      {data?.emailSentDateTime ? (
                        <NuDate
                          value={data?.emailSentDateTime}
                          format="DD-MMM-YYYY, hh:mm A"
                        />
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </div>
                )}
              </div>
            </div>
            {data?.shipmentDetails && (
              <>
                <p className="w-full pt-4 px-1 text-xs font-semibold text-[#111537]">
                  Booking Details
                </p>

                <div className="w-full flex flex-wrap border border-gary mt-2 px-2 rounded-lg">
                  <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 py-1">
                    {data?.shipmentDetails?.bookingDate && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          {" "}
                          Booking Date
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          :{" "}
                          {data?.shipmentDetails?.bookingDate ? (
                            <NuDate
                              value={data?.shipmentDetails?.bookingDate}
                              format="DD-MMM-YYYY"
                            />
                          ) : (
                            "N/A"
                          )}
                        </p>
                      </div>
                    )}
                    {data?.shipmentDetails?.agent && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          {" "}
                          Agent
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          : {data?.shipmentDetails?.agentName || "N/A"}
                        </p>
                      </div>
                    )}
                    {data?.shipmentDetails?.modeOfShipment && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          {" "}
                          Mode Of Shipment
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          : {data?.shipmentDetails?.modeOfShipment}
                        </p>
                      </div>
                    )}
                    {data?.shipmentDetails?.permitReq && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          {" "}
                          Permit Required?
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          :{" "}
                          {data?.shipmentDetails?.permitReq
                            ? data?.shipmentDetails?.permitReq
                              ? "Yes"
                              : "No"
                            : "-"}
                        </p>
                      </div>
                    )}
                    {data?.shipmentDetails?.ETD && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          {" "}
                          ETD{" "}
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          :{" "}
                          {data?.shipmentDetails?.ETD ? (
                            <NuDate
                              value={data?.shipmentDetails?.ETD}
                              format="DD-MMM-YYYY"
                            />
                          ) : (
                            "N/A"
                          )}
                        </p>
                      </div>
                    )}
                    {data?.shipmentDetails?.ETA && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          {" "}
                          ETA
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          :{" "}
                          {data?.shipmentDetails?.ETA ? (
                            <NuDate
                              value={data?.shipmentDetails?.ETA}
                              format="DD-MMM-YYYY"
                            />
                          ) : (
                            "N/A"
                          )}
                        </p>
                      </div>
                    )}

                    {data?.shipmentDetails?.ESC && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          Estimated Shipping Cost
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          : {data?.shipmentDetails?.ESC}
                        </p>
                      </div>
                    )}

                    {data?.shipmentDetails?.ASC && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          Actual Shipping Cost{" "}
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          : {data?.shipmentDetails?.ASC}
                        </p>
                      </div>
                    )}

                    {data?.shipmentDetails?.shipmentBill && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          Shipment Bill No.
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                          : {data?.shipmentDetails?.shipmentBill}
                        </p>
                      </div>
                    )}
                    {data?.shipmentDetails?.trackingUrl && (
                      <div className="w-full flex px-2 items-center">
                        <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          {" "}
                          Tracking Url
                        </p>
                        <p className="w-2/3 py-2 text-xs font-medium truncate text-[#606279] break-words">
                          : {data?.shipmentDetails?.trackingUrl}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <div className="w-full sm:w-1/2">
                <p className="text-xs font-semibold text-[#111537] p-1">
                  Billing Address
                </p>
                <div className="border border-gary p-2 h-28 overflow-y-scroll rounded-lg items-center">
                  <div className="flex flex-wrap gap-1">
                    {data?.billingAddressLine1 && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.billingAddressLine1 || ""} ,
                      </p>
                    )}
                    {data?.billingAddressLine2 && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.billingAddressLine2 || ""},
                      </p>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {data?.billing_city && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.billing_city || ""} ,
                      </p>
                    )}
                    {data?.billing_state && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.billing_state || ""},
                      </p>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {data?.billing_country && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.billing_country || ""} ,
                      </p>
                    )}
                    {data?.billing_postal_code && (
                      <p className="text-xs break-words text-[#606279]">
                        pin-{data?.billing_postal_code || 0}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-full sm:w-1/2">
                <p className="p-1 text-xs font-semibold text-[#111537]">
                  Delivery Address
                </p>
                <div className="border border-gary overflow-y-scroll h-28 rounded-lg p-2">
                  <div className="flex flex-wrap gap-1">
                    {data?.deliveryAddressLine1 && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.deliveryAddressLine1 || ""} ,
                      </p>
                    )}
                    {data?.deliveryAddressLine2 && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.deliveryAddressLine2 || ""},
                      </p>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {data?.delivery_city && (
                      <p className="text-xs break-words text-[#606279]">
                        {data.delivery_city || ""} ,
                      </p>
                    )}
                    {data?.delivery_state && (
                      <p className="text-xs break-words text-[#606279]">
                        {data?.delivery_state || ""},
                      </p>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {data?.delivery_country && (
                      <p className="text-xs break-words text-[#606279]">
                        {data.delivery_country || ""} ,
                      </p>
                    )}
                    {data?.delivery_postal_code && (
                      <p className="text-xs break-words text-[#606279]">
                        pin-{data?.delivery_postal_code || 0}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>



            <div className="w-full bg-white border border-gary mt-4 rounded-lg overflow-x-auto">
              <div className="w-full min-w-[600px]">
                <div className="w-full py-2 bg-baseColor-primary flex justify-between rounded-t-lg px-2">
                  <p className="w-[5%] text-center text-white text-xs font-medium p-1">
                    S.N.{" "}
                  </p>
                  <p className="w-[35%] text-left text-white text-xs font-medium p-1">
                    {" "}
                    Product{" "}
                  </p>
                  <p className="w-[8%] text-center text-white text-xs font-medium p-1">
                    {" "}
                    Unit
                  </p>
                  <p className="w-[10%] text-center text-white text-xs font-medium p-1">
                    {" "}
                    Req.Qty
                  </p>
                  <p className="w-[10%] text-center text-white text-xs font-medium p-1">
                    {" "}
                    Ord. Qty{" "}
                  </p>
                  <p className="w-[10%] text-center text-white text-xs font-medium p-1">
                    {" "}
                    Price
                  </p>
                  <p className="w-[11%] text-center text-white text-xs font-medium p-1">
                    {" "}
                    Neg.Price
                  </p>
                  <p className="w-[11%] text-center text-white text-xs font-medium p-1">
                    Total
                  </p>
                </div>
                {data?.products?.length > 0 &&
                  data?.products?.map((List, index) => {
                    return (
                      <div
                        key={index}
                        className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100 px-2"
                      >
                        <p className="w-[5%] text-center pl-1 text-xs font-medium text-[#111537] py-1">
                          {index + 1}
                        </p>
                        <div className="w-[35%]">
                          <p className="text-left text-xs font-medium text-[#111537] py-1 break-words">
                            {List?.product_name}
                          </p>
                          {List?.notes && (
                            <div className="relative group">
                              <p className="text-left text-red-500 text-xs truncate break-words">
                                Notes : {List?.notes}
                              </p>
                              <div className="absolute hidden group-hover:block bg-gray-100 text-[#111537] text-[11.5px] font-light rounded-md px-1 py-1 w-max max-w-xs z-10">
                                {List?.notes}
                              </div>
                            </div>
                          )}
                        </div>
                        <p className="w-[8%] text-center text-xs font-medium text-[#111537] py-1">
                          {List?.unit}
                        </p>
                        <p className="w-[10%] text-center text-xs font-medium text-[#111537] py-1">
                          {List?.requestedQty}
                        </p>
                        <p className="w-[10%] text-center text-xs font-medium text-[#111537] py-1">
                          {List?.orderedQty}
                        </p>
                        <p className="w-[10%] text-center text-xs font-medium text-[#111537] py-1">
                          {(Number(List?.price) || 0).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </p>
                        <p className="w-[11%] text-center text-xs font-medium text-[#111537] py-1">
                          {(Number(List?.negotiatedPrice) || 0).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </p>
                        <p className="text-center w-[11%] text-xs font-medium text-[#111537] py-1">
                          {(
                            List.negotiatedPrice * List.orderedQty
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </p>
                      </div>
                    );
                  })}
                <div className="w-full flex flex-col items-end px-4 py-2">
                  <div className="flex items-center">
                    <p className="py-1 text-xs font-medium text-[#111537] min-w-[90px]">
                      Total Price
                    </p>
                    <p className="py-1 text-xs font-medium">
                      :{" "}
                      <NuAmount
                        currency={String(data?.vendorCurrency).toUpperCase()}
                        value={data?.totalPrice}
                      />
                    </p>
                  </div>
                  {isLocal && (
                    <>
                      <div className="flex items-center">
                        <p className="py-1 text-xs font-medium text-[#111537] min-w-[90px]">
                          VAT ({vatRate}%)
                        </p>
                        <p className="py-1 text-xs font-medium">
                          :{" "}
                          <NuAmount
                            currency={String(data?.vendorCurrency).toUpperCase()}
                            value={((Number(data?.totalPrice) || 0) * vatRate) / 100}
                          />
                        </p>
                      </div>
                      <div className="flex items-center border-t border-gray-300 mt-1 pt-1">
                        <p className="py-1 text-xs font-bold text-[#111537] min-w-[90px]">
                          Grand Total
                        </p>
                        <p className="py-1 text-xs font-bold">
                          :{" "}
                          <NuAmount
                            currency={String(data?.vendorCurrency).toUpperCase()}
                            value={
                              (Number(data?.totalPrice) || 0) +
                              ((Number(data?.totalPrice) || 0) * vatRate) / 100
                            }
                          />
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[30%] bg-white rounded-lg drop-shadow-lg p-2 flex flex-col gap-3 lg:overflow-y-auto">
          <div className="w-full p-1 flex flex-col gap-3">
            <ApprovalComponent
              id={id}
              getUrl={getUrl}
              putUrl={putUrl}
              statusUrl={statusUrl}
              undoUrl={undoUrl}
              editUrl={editUrl}
              refSetData={setData}
              data={data}
              type={"PO"}
              preUrlName={"PO"}
            />

            <div className="w-full grid border border-gary mt-2 rounded-lg overflow-hidden">
              <div className="bg-baseColor-primary p-2">
                <p className="text-xs text-white font-medium">Supplier Detail</p>
              </div>
              <div className="w-full flex px-2 justify-between items-center">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                  YPR
                </p>
                <div className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                  <p>: {data?.prRrf} </p>
                  <p className="pl-1.5">
                    {data?.prDate ? (
                      <NuDate
                        value={data?.prDate}
                        format="DD-MMM-YYYY, hh:mm A"
                      />
                    ) : (
                      " "
                    )}
                  </p>
                </div>
              </div>
              <div className="w-full flex px-2 justify-between items-center">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                  Supplier
                </p>
                <p className="w-2/3 py-2 text-xs font-medium text-[#606279] break-words">
                  : {data?.vendorName}
                  {isLocal && " (Local)"}
                </p>
              </div>
            </div>
            <div className="w-full grid border border-gary mt-2 rounded-lg overflow-hidden">
              <p className="text-xs text-white font-medium bg-baseColor-primary p-2">
                Documents{" "}
              </p>
              <div className="w-full flex flex-wrap p-2 gap-1 max-h-32 overflow-y-auto">
                {isApprovalVerified() && (
                  <div
                    onClick={handlePdfIconClick}
                    className="cursor-pointer m-1 w-auto h-[25px] flex items-center justify-between rounded p-[2px] border"
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="#048178"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                    </svg>
                    <p className="w-auto text-[9px] truncate max-w-[120px]">
                      {data?.ref}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full h-auto flex border border-gary mt-2 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.prId}
                addurl={"/pr-comments/new-comment"}
                geturl={`/pr-comments/by-PR/${data?.prId}`}
              />
            </div>
          </div>
        </div>
      </div>
      {showPdfComponent && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll flex flex-col">
            <button
              className="absolute top-2 right-2 text-white bg-red-600 rounded p-1 z-10"
              onClick={() => setShowPdfComponent(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            {pdfLoading ? (
              <div className="w-full h-full flex flex-col items-center justify-center gap-3">
                <div className="w-8 h-8 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-600 font-medium text-sm">Loading PDF preview...</p>
              </div>
            ) : (
              <PDFViewer pdfFile={viewPDF} />
            )}
          </div>
        </div>
      )}

      {isCommentsModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-lg font-semibold mb-4">GRN Modal</h2>

            <div>
              {grnData && grnData.length > 0 ? (
                <table className="min-w-full table-auto border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100 text-sm text-left">
                      <th className="border border-gray-300 p-2">YPR</th>
                      <th className="border border-gray-300 p-2">GRN No.</th>
                      <th className="border border-gray-300 p-2">PO No.</th>
                      <th className="border border-gray-300 p-2">DN No.</th>
                      <th className="border border-gray-300 p-2">Received Date</th>
                      <th className="border border-gray-300 p-2"> Approval Status</th>
                      <th className="border border-gray-300 p-2">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grnData.map((item, index) => (
                      <tr key={index} className="text-sm">
                        <td className="border border-gray-300 p-2">{item.prRef}</td>
                        <td className="border border-gray-300 p-2">{item.ref}</td>
                        <td className="border border-gray-300 p-2">{item.poRef}</td>
                        <td className="border border-gray-300 p-2">{item.dnRef}</td>
                        <td className="border border-gray-300 p-2">{item.receivedDate}</td>
                        <td className="border border-gray-300 p-2">{item.approvalStatus}</td>
                        <td className="border border-gray-300 p-2">{item.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No data available</p>
              )}
            </div>

            <div className="flex justify-end mt-4">
              <button
                className="px-5 py-[9px] cursor-pointer text-xs bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
                onClick={handleCloseCommentsModal}
              >
                Close
              </button>
              <button
                type="submit"
                className="bg-[#048178] px-5 py-[8px] cursor-pointer outline-none border-none text-white rounded-md text-xs flex items-center"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* {showQuoteComparison && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[98vw] h-[96vh] bg-white py-2 px-2 lg:py-4 lg:px-6 rounded-md shadow-lg">
            <div className="w-full h-30 flex justify-between">
              <h2 className="text-sm 2xl:text-base font-semibold mb-4">
                Quote Comparison
              </h2>
              <div
                className="w-6 h-6 bg-baseColor-primary rounded-sm cursor-pointer"
                onClick={closeQouteComparison}
              >
                <p className="text-center py-1 text-white text-xs">X</p>
              </div>
            </div>
            <div className="overflow-x-auto w-full rounded-lg">
              <div className="w-full min-h-[calc(100vh-250px)] max-h-[calc(100vh-120px)] overflow-y-scroll">
                {isLoadingQuote ? (
                  <div className="w-full p-4">
                    {[...Array(5)].map((_, index) => (
                      <div
                        key={index}
                        className="animate-pulse flex space-x-4 mb-4"
                      >
                        <div className="rounded-full bg-slate-200 h-10 w-10"></div>
                        <div className="flex-1 space-y-6 py-1">
                          <div className="h-4 bg-slate-200 rounded"></div>
                          <div className="space-y-3">
                            <div className="grid grid-cols-3 gap-4">
                              <div className="h-4 bg-slate-200 rounded col-span-2"></div>
                              <div className="h-4 bg-slate-200 rounded col-span-1"></div>
                            </div>
                            <div className="h-4 bg-slate-200 rounded"></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className={
                      supplierList?.length > 10
                        ? `min-w-[4900px]`
                        : supplierList?.length > 6
                          ? `min-w-[3900px]`
                          : supplierList?.length > 4
                            ? `min-w-[2900px]`
                            : supplierList?.length > 1
                              ? `min-w-[1800px]`
                              : `min-w-[750px] sm:min-w-[900px] md:min-w-[1100px]`
                    }
                  >
                    <table className="table-auto relative min-w-full border-collapse border border-slate-300 z-0">
                      <thead className="bg-baseColor-primary sticky top-0 text-white text-xs 2xl:text-sm z-[1]">
                        <tr>
                          <th
                            rowSpan={2}
                            className="py-1 lg:sticky lg:left-0 w-[270px] min-w-[270px] sm:w-[365px] sm:min-w-[365px] md:w-[445px] md:min-w-[445px] lg:w-[470px] lg:min-w-[470px] bg-baseColor-primary z-10 border-r border-slate-100 align-middle"
                          >
                            <div className="flex w-full h-full items-center">
                              <div className="w-[35px] sm:w-[45px] h-full flex justify-center items-center text-center border-r border-[#acaaaa] shrink-0">
                                S.N.
                              </div>
                              <div className="flex-1 h-full flex justify-center items-center text-left border-r border-[#acaaaa] px-1">
                                Product
                              </div>
                              <div className="w-[50px] sm:w-[65px] md:w-[75px] h-full flex justify-center items-center text-right border-r border-[#acaaaa] shrink-0 pr-1">
                                Unit
                              </div>
                              <div className="w-[45px] sm:w-[55px] md:w-[65px] h-full flex justify-center items-center text-right pr-1 shrink-0">
                                Qty
                              </div>
                            </div>
                          </th>

                          {supplierList.map((sub, index) => (
                            <th
                              key={`supplier-top-${index}`}
                              colSpan={3}
                              className="border-r border-[#acaaaa] px-2 py-1 bg-baseColor-primary border-b border-white/20 w-[350px] min-w-[350px]"
                            >
                              <div className="flex justify-between items-center text-xs w-full">
                                <div className="text-left shrink-0 max-w-[160px]">
                                  <p className="font-semibold text-white text-xs truncate">
                                    {sub?.name || `Supplier ${index + 1}`}
                                  </p>
                                  <p className="text-[10px] font-light opacity-90 truncate">
                                    {sub?.type || ""}
                                  </p>
                                </div>
                                <div className="text-left text-[9px] leading-3 shrink-0">
                                  <div>Ref : {sub?.ref || "#"}</div>
                                  <div>
                                    Prepared By :{" "}
                                    <span className="capitalize">
                                      {sub?.preparedBy || "-"}
                                    </span>
                                  </div>
                                </div>
                                <div className="text-left text-[9px] leading-3 shrink-0">
                                  <div>
                                    {sub?.date ? (
                                      <NuDate
                                        value={sub?.date}
                                        format="DD-MMM-YYYY"
                                      />
                                    ) : (
                                      "date"
                                    )}
                                  </div>
                                  <div>
                                    Purchaser :{" "}
                                    <span className="capitalize">
                                      {sub?.purchaser || "-"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </th>
                          ))}
                        </tr>
                        <tr>
                          {supplierList.map((sub, index) => (
                            <React.Fragment key={`supplier-sub-${index}`}>
                              <th className="w-[140px] min-w-[140px] py-1.5 border-r border-[#acaaaa] bg-baseColor-primary text-center font-semibold text-xs">
                                <div className="flex items-center justify-center gap-1 relative">
                                  <span>Unit Price</span>
                                  <div className="popover-menu cursor-pointer relative inline-block">
                                    <span>
                                      <Info color="white" />
                                    </span>
                                    <div className="hidden absolute z-50 top-4 right-3 popover-menu-item font-medium border border-teal-700 text-black bg-white text-xs rounded-lg p-2 shadow-lg min-w-[250px]">
                                      <table className="text-left border-collapse w-full">
                                        <TempCom
                                          label="LCost"
                                          value={sub?.lCost || "0"}
                                        />
                                        <TempCom
                                          label="Other"
                                          value={sub?.others || "0"}
                                        />
                                        <TempCom
                                          label="Total"
                                          value={sub?.boxTotal || "0"}
                                        />
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </th>
                              <th className="w-[60px] min-w-[60px] py-1.5 border-r border-[#acaaaa] bg-baseColor-primary text-center font-semibold text-xs">
                                GP
                              </th>
                              <th className="w-[150px] min-w-[150px] py-1.5 border-r border-[#acaaaa] bg-baseColor-primary text-center font-semibold text-xs">
                                Selling Price
                              </th>
                            </React.Fragment>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {dataView &&
                          dataView.map((item, index) => (
                            <tr
                              key={index}
                              className="odd:bg-white even:bg-slate-50 text-xs 2xl:text-sm border-collapse border border-slate-300"
                            >
                              <td
                                className={`text-center lg:sticky lg:left-0 w-[270px] min-w-[270px] sm:w-[365px] sm:min-w-[365px] md:w-[445px] md:min-w-[445px] lg:w-[470px] lg:min-w-[470px] ${index % 2 !== 0 ? "bg-slate-50" : "bg-white"
                                  }`}
                              >
                                <div className="flex w-full items-center min-h-16">
                                  <div className="w-[35px] sm:w-[45px] text-center min-h-16 border-r border-[#acaaaa] flex justify-center items-center shrink-0">
                                    {item.display_sno || item.sno || item.sNo}
                                  </div>
                                  <div className="flex-1 text-left min-h-16 border-r border-[#acaaaa] flex justify-start px-1 sm:px-2 items-center">
                                    <p className="truncate whitespace-normal line-clamp-2">
                                      {item.name}
                                      {item.alternate === true && (
                                        <span className="text-green-500 block w-[90px] rounded-md font-normal text-[8px]">
                                          Alternate Item
                                        </span>
                                      )}
                                    </p>
                                  </div>
                                  <div className="w-[50px] sm:w-[65px] md:w-[75px] text-center min-h-16 border-r border-[#acaaaa] flex justify-center items-center shrink-0">
                                    {item.unit}
                                  </div>
                                  <div className="w-[45px] sm:w-[55px] md:w-[65px] text-center pr-1 min-h-16 flex justify-center items-center shrink-0">
                                    {item.requestedQty}
                                  </div>
                                </div>
                              </td>

                              {supplierList.map((sub, sIndex) => {
                                const supplier = stateValue.find(
                                  (i) =>
                                    i.productId === item.id &&
                                    i.quoteId === sub.quoteId
                                );
                                if (supplier) {
                                  return (
                                    <React.Fragment
                                      key={`dynamic-cell-${index}-${sIndex}`}
                                    >
                                      <td className="py-2 text-center border-collapse border-x border-y-0 w-[140px] border-slate-300">
                                        <div className="flex justify-center text-center items-center">
                                          <div className="popover-menu cursor-pointer relative hover:z-[60]">
                                            <span>
                                              <Info />
                                            </span>
                                            <div className="hidden absolute z-[60] right-4 top-6 popover-menu-item font-medium border border-teal-700 bg-white text-xs rounded-lg p-2 shadow-lg min-w-[350px]">
                                              <table className="text-left border-collapse w-full">
                                                <TempCom
                                                  label="Supplier Price"
                                                  value={`${supplier?.currencyLabel || ""
                                                    } ${supplier?.unitPrice || "0"
                                                    }`}
                                                />
                                                <TempCom
                                                  label="Converted Price"
                                                  value={
                                                    <NuAmount
                                                      value={
                                                        supplier?.convertedPrice ||
                                                        "0"
                                                      }
                                                    />
                                                  }
                                                />
                                                <TempCom
                                                  label="Duty"
                                                  value={`${supplier?.dutty || "0"}%`}
                                                  calculation={
                                                    supplier?.dutty &&
                                                      supplier?.convertedPrice
                                                      ? (
                                                        (supplier?.convertedPrice /
                                                          100) *
                                                        supplier?.dutty
                                                      ).toFixed(2)
                                                      : null
                                                  }
                                                />
                                                <TempCom
                                                  label="Trans. + Exp"
                                                  value={
                                                    <NuAmount
                                                      value={
                                                        supplier?.trans || "0"
                                                      }
                                                    />
                                                  }
                                                />
                                                <TempCom
                                                  label="Landing Cost"
                                                  value={
                                                    <NuAmount
                                                      value={
                                                        supplier?.landedCost || "0"
                                                      }
                                                    />
                                                  }
                                                />
                                                <TempCom
                                                  label="Final Unit Price"
                                                  value={
                                                    <NuAmount
                                                      value={
                                                        supplier?.LCSP || "0"
                                                      }
                                                    />
                                                  }
                                                />
                                              </table>
                                            </div>
                                          </div>

                                          <input
                                            type="checkbox"
                                            checked={supplier.isSelected}
                                            disabled={true}
                                            className="ml-1 mr-1"
                                          />
                                          {supplier?.LCSP
                                            ? parseFloat(
                                              supplier.LCSP
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })
                                            : "-"}
                                        </div>
                                        <div className="text-[10px] text-gray-500">
                                          {supplier?.leadTime ||
                                            "Lead Time : None"}
                                        </div>
                                      </td>
                                      <td className="py-2 text-center border-collapse border-x border-y-0 w-[60px] border-slate-300">
                                        <div className="w-full h-full flex justify-evenly px-1">
                                          <input
                                            type="number"
                                            className="w-full py-1 px-1 text-center focus:outline-none rounded bg-slate-200"
                                            value={parseFloat(supplier.gp) || 0}
                                            disabled={true}
                                          />
                                        </div>
                                      </td>
                                      <td
                                        className={`py-2 text-center border-collapse border-x border-y-0 w-[150px] border-slate-300 ${supplier.isLow === true &&
                                          supplier.isHigh === true
                                          ? "bg-green-100"
                                          : supplier.isHigh === true &&
                                            supplier?.LCSP > 0
                                            ? "bg-red-100"
                                            : supplier.isLow === true &&
                                              supplier?.LCSP > 0
                                              ? "bg-green-100"
                                              : ""
                                          }`}
                                      >
                                        <div className="w-full h-full">
                                          <NuAmount
                                            value={
                                              supplier?.sellingPrice || 0
                                            }
                                          />
                                        </div>
                                        <div className="text-[10px] text-gray-500">
                                          Total :{" "}
                                          <NuAmount
                                            value={
                                              parseFloat(
                                                supplier?.sellingPrice
                                              ) *
                                              parseFloat(
                                                item.requestedQty
                                              ) || 0
                                            }
                                          />
                                          {supplier.isLow !== true &&
                                            supplier?.sellingPrice > 0 && (
                                              <span className="ml-1 w-full text-[10px] text-red-700 truncate">
                                                {CalPercentage(
                                                  stateValue,
                                                  supplier,
                                                  item?.name
                                                )}
                                              </span>
                                            )}
                                        </div>
                                      </td>
                                    </React.Fragment>
                                  );
                                } else {
                                  return (
                                    <React.Fragment
                                      key={`dynamic-cell-${index}-${sIndex}`}
                                    >
                                      <td
                                        colSpan={3}
                                        className="border-collapse border-x border-y-0 border-slate-300"
                                      ></td>
                                    </React.Fragment>
                                  );
                                }
                              })}
                            </tr>
                          ))}
                        <tr className="bg-white text-xs 2xl:text-sm font-bold">
                          <td className="py-2 text-center lg:sticky lg:left-0 w-[270px] min-w-[270px] sm:w-[365px] sm:min-w-[365px] md:w-[445px] md:min-w-[445px] lg:w-[470px] lg:min-w-[470px] bg-white z-[0]"></td>

                          {supplierList?.map((sub, supplierIndex) => {
                            const totalPrice = stateValue
                              .filter((i) => i.quoteId === sub.quoteId)
                              .reduce(
                                (total, supplier) =>
                                  total +
                                  parseFloat(supplier.sellingPrice || 0) *
                                  parseFloat(supplier?.requestedQty),
                                0
                              );

                            return (
                              <React.Fragment
                                key={`total-row-${supplierIndex}`}
                              >
                                <td className="py-2 text-center w-[140px] border-r border-slate-200"></td>
                                <td className="py-2 text-center w-[60px] border-r border-slate-200"></td>
                                <td className="py-2 text-center w-[150px] px-2 border-r border-slate-200">
                                  <div className="flex gap-2 text-[10px] text-gray-500 justify-center">
                                    <span>Total:</span>
                                    <NuAmount value={totalPrice} />
                                  </div>
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )} */}
      <QuoteComparisonModal
        isOpen={showQuoteComparison}
        prId={data?.prId}
        onClose={() => setShowQuoteComparison(false)}
      />
    </div>
  );
}

export default ViewPo;

function TempCom({ label = "", value = 0, calculation = 0 }) {
  return (
    <tr className="w-full">
      <td className="w-[150px] py-1">{label}</td>
      <td className="w-[10px] py-1">:</td>
      <td className="min-w-[130px] py-1">
        {value}
        {label === "Duty" && calculation !== null && (
          <span>
            {" ("}
            <NuAmount value={calculation} />
            {")"}
          </span>
        )}
      </td>
    </tr>
  );
}
